// extracted by mini-css-extract-plugin
export default {"root":"tMP2ux","playerWrapper":"KE9ORN","alignmentWrapper":"ICGtQ9"};